var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M34.9,14.4c1.9-3.2,0.8-6.4,0.8-6.4S34.8,4,29,4C14.8,4,9,39,9,39s2,3,15,3s15-3,15-3 c-2.5-12.8-9.4-26.6-9.4-26.6S27.8,9,30.7,9c2,0,2.3,5,2.3,5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M35,14c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S35,13.4,35,14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce93d8",
    d: "M24,44c-12,0-15.5-1.9-16.1-2.3c-0.9-0.6-1.2-1.9-0.6-2.8c0.6-0.9,1.8-1.2,2.7-0.6 C10.2,38.4,13.4,40,24,40c10.8,0,13.9-1.7,14-1.7c0.9-0.6,2.1-0.3,2.7,0.6c0.6,0.9,0.3,2.2-0.6,2.8C39.5,42.1,36,44,24,44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M20.8 17l1 2 2.2.3-1.6 1.5.4 2.2-1.9-1-1.9 1 .4-2.2-1.6-1.5 2.2-.3L20.8 17zM17.2 26l1 2 2.2.3-1.6 1.5.4 2.2-1.9-1-1.9 1 .4-2.2L14 28.3l2.2-.3L17.2 26zM27.5 27.5c0-2.6 1.9-4.6 4.4-4.9-.7-.4-1.5-.6-2.4-.6-3 0-5.5 2.5-5.5 5.5s2.5 5.5 5.5 5.5c.9 0 1.7-.2 2.4-.6C29.4 32.1 27.5 30.1 27.5 27.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M35,14c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S35,13.4,35,14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#311b92",
    d: "M29.6,12.4c0,0-1.8-3.4,1.1-3.4c2,0,2.3,5,2.3,5c0,0.6,0.4,1,1,1c0.4,0,0.7-0.2,0.9-0.6h0 c0.8-1.3,1-2.5,1.1-3.6C35.9,8.4,33.4,6,31,6c-2.5,0-3,1.5-3,3c0,2,1.8,4.5,2.6,5.6C30,13.2,29.6,12.4,29.6,12.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizard);
export default __webpack_public_path__ + "static/media/wizard.4a1506517ec013daf3eedee27f4f61ed.svg";
export { ForwardRef as ReactComponent };